export default "__VITE_ASSET__ChuK5240__"